import AlertOldBrowser from 'components/alert-old-browser';

const alertOldBrowser = new AlertOldBrowser();
const ver = $(`script[src*='alert.js']`).attr('src').split('?')[1]; // eslint-disable-line

alertOldBrowser.init();
alertOldBrowser.addScript(`/scripts/app.js?${ver}`);
